import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { BotaoGridCurriculo } from './botaoGridCurriculo.component'

import { ExibirMenuService } from '../../shared/exibir-menu.service'
import { DadosAcessoService } from '../../../dadosAcesso.service'
import { AcessoApiService } from '../../../acessoApi.service'
import {AgGridModule} from 'ag-grid-angular/main';

@Component({
  selector: 'app-curriculo',
  templateUrl: './curriculo.component.html',
  styleUrls: ['./curriculo.component.css']
})
export class CurriculoComponent implements OnInit {

  public colDef: any
  private frameworkComponents;
  private columnDefs;
  private rowData;
  private context;
  public arrayCurriculo: any
  public statusSelecionado: string
  public statusInicial: string = "A"
  public status1: string = 'B'
  public status2: string = 'C'
  public status3: string = 'D'
  public status4: string = 'E'
  public status5: string = 'F'

  constructor(private exibirItens: ExibirMenuService,private acessoAPI: AcessoApiService, private dadosAcesso: DadosAcessoService, private router: Router) { 
    if(sessionStorage.getItem('cod_loja') === null){

      this.router.navigate(["/"])
    }
    this.exibirItens.setItensVisiveis(true);

    this.acessoAPI.CarregarCurriculos(this.statusInicial).subscribe(res =>{
      this.arrayCurriculo = res
  
      this.rowData = this.arrayCurriculo
  
    }, error =>{
     
    })

    this.columnDefs = [
      {headerName: 'Nome', field: 'nome_pessoa' },
      {headerName: 'Cadastro', field: 'datacad_cand' },
      {headerName: 'Interesses', field: 'interesse_cand'},
      {headerName: 'Status', field: 'curriculo_cand'},
      {headerName: 'Análise', field: 'analise_cand'},
      {headerName: '', field: 'cod_cand', cellRenderer:"botaoGridCurriculo", colId: 'cod_cand', width: 100}
  ];
  
  this.context = { componentParent: this };
  
  this.frameworkComponents = {
    botaoGridCurriculo: BotaoGridCurriculo
  }



  }

  ngOnInit() {
  }

  changeStatus(status){

    this.statusSelecionado = status.value;

    this.acessoAPI.CarregarCurriculos(this.statusSelecionado).subscribe(res =>{
      this.arrayCurriculo = res
     
  
      this.rowData = this.arrayCurriculo
  
    }, error =>{
     
    })
 }

}



// WEBPACK FOOTER //
// ./src/app/pages/administracao/curriculo/curriculo.component.ts